import React, { useState } from 'react'
import useOutsideClick from '@helpers/hooks/useOutsideClick'
import Translations from '@helpers/translations'
import SizeChartNav from '../SizeChartNav'
import styles from './styles.module.scss'

type SizeChartHeaderProps = {
  setProductCategory: (category: string) => void
  productCategory: string
  options: string[]
}

const SizeChartHeader = ({
  setProductCategory,
  productCategory,
  options
}: SizeChartHeaderProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const ref = useOutsideClick<HTMLButtonElement>(() => setIsOpen(false))

  const handleClick = () => {
    setIsOpen(!isOpen)
  }

  return (
    <header className={styles.sizeChart__header}>
      <h1 className={`${styles.sizeChart__title} h2`}>
        {Translations.localise('pages.size-chart.size-and-fit')}{' '}
        <span>{Translations.localise('pages.size-chart.for')}</span>
      </h1>

      <div className={styles.sizeChart__dropdown} data-open={isOpen}>
        <button
          ref={ref}
          type="button"
          className={styles.sizeChart__button}
          onClick={handleClick}
        >
          {Translations.localise(
            `pages.size-chart.${productCategory.toLowerCase()}`
          )}
        </button>
        <SizeChartNav
          options={options}
          setProductCategory={setProductCategory}
          productCategory={productCategory}
          isOpen={isOpen}
        />
      </div>
    </header>
  )
}

export default SizeChartHeader
